

import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FaPaperPlane, FaUpload, FaMicrophone } from "react-icons/fa";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import Select from "react-select";

const MaterialWastageLogModal = ({ show, handleClose, onWastageLog }) => {
  const [material, setMaterial] = useState([]);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    material_id: "",
    quantity: "",
    unit: "",
    reason: "",
  });

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" })); 
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }

    try {
      const payload = { ...form };

      const response = await axios.post(
        `${config.API}/supervisor/materialwaste`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success(
          response.data.message || "Request submitted successfully!"
        );
        setForm({
          material_id: "",
          quantity: "",
          unit: "",
          reason: "",
        });
        setErrors({});
        handleClose();
        onWastageLog();
      } else {
        if (response.data.errors) {
          setErrors(response.data.errors);
        }
      }
    } catch (err) {
      console.error("Error submitting material issue:", err.message);
      toast.error("Failed to submit material issue request!");
    }
  };

  useEffect(() => {
    fetchMaterialList();
  }, []);

  const fetchMaterialList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/material/master/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setMaterial(
        response?.data?.materials?.map((item) => ({
          value: item.id,
          label: item.material_name,
        })) || []
      );
    } catch (err) {
      console.error("Error fetching materials:", err.message);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md" className="font_family">
      <Modal.Header closeButton>
            <strong className="fs-4">Material Wastage Log Window</strong>
      </Modal.Header>
      <Modal.Body className="">
        <Form>
          {/* Material Dropdown */}
          <Form.Group as={Row} className="align-items-center mb-4 mt-4">
            <Form.Label column md={2}>
              <strong>Material</strong>
            </Form.Label>
            <Col md={10}>
              <Select
                options={material}
                value={material.find((opt) => opt.value === form.material_id) || null}
                onChange={(selected) =>
                  handleChange("material_id", selected ? selected.value : "")
                }
                placeholder="Select material"
                className={errors.material_id ? "is-invalid" : ""}
              />
              {errors.material_id && (
                <div className="text-danger small">{errors.material_id[0]}</div>
              )}
            </Col>
          </Form.Group>

          {/* Quantity and Unit */}
          <Form.Group as={Row} className="align-items-center mb-4">
            <Form.Label column md={2}>
              <strong>Quantity</strong>
            </Form.Label>
            <Col md={4}>
              <Form.Control
                type="number"
                name="quantity"
                value={form.quantity}
                onChange={(e) => handleChange("quantity", e.target.value)}
                className={errors.quantity ? "is-invalid" : ""}
              />
              {errors.quantity && (
                <div className="text-danger small">{errors.quantity[0]}</div>
              )}
            </Col>
            <Form.Label column md={2}>
              <strong>Unit</strong>
            </Form.Label>
            <Col md={4}>
              <Select
                options={[
                  { value: "kg", label: "kg" },
                  { value: "pcs", label: "pcs" },
                ]}
                value={
                  form.unit ? { value: form.unit, label: form.unit } : null
                }
                onChange={(selected) =>
                  handleChange("unit", selected ? selected.value : "")
                }
                placeholder="unit"
              />
            </Col>
          </Form.Group>

          {/* Reason Text Area & Tools */}
          <Form.Group>
            <div className="border rounded p-3">
              <div className="bg-light p-2 rounded mb-3 text-muted small">
                Please describe the reason for material wastage.
                <br />
                You can provide details about what you’re seeing, upload an
                image, or use voice input.
              </div>

              <div className="border rounded p-2">
                <div className="d-flex align-items-center">
                  {/* Left buttons */}
                  <div className="d-flex gap-2">
                    <Button variant="light" className="border">
                      <FaUpload />
                    </Button>
                    <Button variant="light" className="border">
                      <FaMicrophone />
                    </Button>
                  </div>

                  {/* Textarea */}
                  <div className="flex-grow-1 mx-2">
                    <textarea
                      className={`form-control border-0 shadow-none ${
                        errors.reason ? "is-invalid" : ""
                      }`}
                      rows="1"
                      placeholder="Type here..."
                      style={{ resize: "none" }}
                      name="reason"
                      value={form.reason}
                      onChange={(e) => handleChange("reason", e.target.value)}
                    ></textarea>
                    {errors.reason && (
                      <div className="text-danger small">{errors.reason[0]}</div>
                    )}
                  </div>

                  {/* Send button */}
                  <div>
                    <Button variant="primary" onClick={handleSubmit}>
                      <FaPaperPlane />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default MaterialWastageLogModal;
